































































import { defineComponent, computed, ref } from "@nuxtjs/composition-api";
import { setTitleVoucher, getDaysUntilExpiry, getCurrentTime } from "~/helpers";
import { useCart } from "~/modules/checkout/composables/useCart";

export default defineComponent({
  name: "VoucherItem",
  components: {},
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    position: {
      type: String,
      default: "",
    },
  },

  setup(props, { root, emit }) {
    const isVoucherDefault = ref(false);

    const change = () => {
      emit("change", props.item);
    };

    const saveVoucher = async () => {
      emit("saveVoucher", props.item);
    };
    const { cart } = useCart();

    const isVoucher = computed(() => {
      if (props.item?.is_collect || isVoucherDefault.value) {
        return true;
      } else {
        // return this.listCouponSever?.find((e) => e == props.item?.coupon_code);
        return false;
      }
    });
    const appliedCoupons = computed(() => cart.value?.applied_coupons || []);

    const isApplied = computed(() => {
      const code = props.item?.voucher_id || props.item?.coupon_code;
      return appliedCoupons.value.some((coupon) => coupon.code === code);
    });

    const goToLink = (urlPath: string) => {
      root.$router.push(urlPath);
    };

    const checkUsed = (item) => {
      if (
        (item.percent_used && item.percent_used == 0) ||
        (item.voucher_type_apply &&
          item.voucher_type_apply === "voucher_offline") ||
        item.voucher_type_apply === "voucher_all"
      ) {
        return true;
      }
      return false;
    };

    return {
      setTitleVoucher,
      getDaysUntilExpiry,
      getCurrentTime,
      saveVoucher,
      isVoucher,
      change,
      goToLink,
      appliedCoupons,
      isApplied,
      checkUsed,
    };
  },
});
